import React from 'react';
import './Services.css';

const Services = () => {
  const deliverySteps = [
    {
      step: 1,
      title: 'Bid Development & Value Engineering',
      introduction: 'We start by understanding your goals and delivering competitive pricing with smart value-adds:',
      activities: [
        'Full takeoff and scope breakdown',
        'Identification of cost-saving opportunities through VE',
        'Preliminary schedule and budget projections',
        'Clarify inclusions/exclusions to eliminate surprises'
      ]
    },
    {
      step: 2,
      title: 'Procurement & Cost Transparency',
      introduction: 'Once awarded, we initiate procurement and lock in transparency:',
      activities: [
        'Material and hardware sourcing based on lead times and specs',
        'Tax, freight, and special treatment clearly itemized',
        'Early coordination with galvanizers, finishers, and mill reps',
        'Purchase order tracking and proactive communication'
      ]
    },
    {
      step: 3,
      title: 'Detailing & Submittals',
      introduction: 'We create detailed, accurate shop drawings for submittal and coordination:',
      activities: [
        'Field measurements and RFI coordination',
        'Early submittals to meet schedule milestones',
        'Engineer review support and client feedback integration',
        'Final stamped and approved drawings for fabrication'
      ]
    },
    {
      step: 4,
      title: 'In-House Steel Fabrication',
      introduction: 'All steel is fabricated under strict in-house quality control:',
      activities: [
        'Cutting, welding, drilling, and prep per AISC standards',
        'Internal QA/QC checkpoints at each fabrication stage',
        'Finish application: paint, galvanize, or specialty coatings',
        'Load prep and bundling based on erection phasing'
      ]
    },
    {
      step: 5,
      title: 'Logistics & Jobsite Readiness',
      introduction: 'We prepare and deliver steel in sync with your schedule:',
      activities: [
        'Coordinated deliveries with just-in-time options',
        'Pre-erection walk-through if needed',
        'Equipment planning and crane scheduling support'
      ]
    },
    {
      step: 6,
      title: 'Steel Erection & Project Closeout',
      introduction: 'Safe, efficient erection and a commitment to finishing strong:',
      activities: [
        'Erection crews mobilized and coordinated with site super',
        'Final welding, bolting, and alignment',
        'Punch list support and final walk-through',
        'Closeout documentation, warranties, and final invoicing'
      ]
    }
  ];

  return (
    <section className="services" id="services">
      <div className="container">
        <h2 className="section-title">BMS Co's Proven 6-Step Delivery Plan</h2>
        <p className="services-subtitle">
          A comprehensive process ensuring quality, transparency, and timely delivery
        </p>
        <div className="services-grid">
          {deliverySteps.map((step, index) => (
            <div key={index} className="service-card">
              <div className="step-number">{step.step}</div>
              <h3 className="service-title">{step.title}</h3>
              <p className="service-description">{step.introduction}</p>
              <ul className="service-features">
                {step.activities.map((activity, activityIndex) => (
                  <li key={activityIndex}>{activity}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;

